export default {
  props: {
    title: String, // Nadpis karty
    icon: String, // Ikonka
    visible: {
      type: Boolean,
      default: true, // Ovládání viditelnosti
    },
    showLine: {
      type: Boolean,
      default: true, // Zobrazit oddělovací čáru
    },
    bordered: {
      type: Boolean,
      default: true, // Ovládání rámečku
    },
  },
}
